import React, { Component } from "react";
import { Link } from "react-router-dom";
import { CopyToClipboard } from "react-copy-to-clipboard";
import {
	Panel,
	PanelHeader,
	PanelBody,
} from "./../../components/panel/panel.jsx";
import {
	UncontrolledButtonDropdown,
	DropdownToggle,
	DropdownMenu,
	DropdownItem,
} from "reactstrap";

import {deletervs, getrvss} from "../../services/rvss.js";
import "bootstrap/dist/css/bootstrap.min.css";
import _ from "lodash";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// Icons imports
import newIcon from "../../assets/Icons/new.svg";
import pdfIcon from "../../assets/Icons/pdf.svg";
import sharingIcon from "../../assets/Icons/sharing.svg";
import trashIcon from "../../assets/Icons/trash.svg";
import xlsIcon from "../../assets/Icons/xls.svg";
import csvIcon from "../../assets/Icons/csv.svg";
import editIcon from "../../assets/Icons/edit.svg";
import importIcon from "../../assets/Icons/import.svg";
import Pagination from "../../common/pagination";
import RVSsTable from "../../components/rvssTable.jsx";
import { paginate } from "../../utils/paginate";
import SearchBox from "./../../common/searchBox";


const apiUrl = process.env.REACT_APP_API_URL;

class rvsTable extends Component {
	constructor(props) {
		super(props);
		this.state = {
			rvss: [],
			pageSize: 20,
			currentPage: 1,
			sortColumn: { path: "title", order: "asc" },
			searchQuery: "",
			checkedFields: [],
		};
		this.handleSort = this.handleSort.bind(this);
		this.handleCheckboxChange = this.handleCheckboxChange.bind(this);	}	async componentDidMount() {
		try {
			const data = await getrvss();
			this.setState({ rvss: data.data });
		} catch (error) {
			console.error("Error fetching rvss:", error);
			
			if (error.response) {
				if (error.response.status === 401) {
					toast.error("Please log in to access this page.");
					// Redirect to login if needed
					window.location.href = "/login";
				} else if (error.response.status === 403) {
					toast.error("You don't have permission to access this resource.");
				} else {
					toast.error("An error occurred while fetching the data.");
				}
			} else {
				toast.error("Network error. Please check your connection.");
			}		}
	}

	// Handle delete for multiple rvss
	async handleMassDelete(data) {
		if (data.length === 0) {
			toast.warning("Please select items to delete.");
			return;
		}

		// Show confirmation dialog
		const confirmDelete = window.confirm(`Are you sure you want to delete ${data.length} RVS record(s)?`);
		if (!confirmDelete) {
			return;
		}

		try {
			for (let i = 0; i < data.length; i++) {
				await deletervs(data[i]);
				const rvss = this.state.rvss.filter(
					(el) => el._id !== data[i]
				);
				this.setState({ rvss });
			}
			
			// Clear checked fields after deletion
			this.setState({ checkedFields: [] });
			toast.success(`${data.length} RVS record(s) deleted successfully!`);
		} catch (error) {
			console.error("Error deleting RVS records:", error);
			toast.error("Failed to delete RVS records.");
		}
	}

	handleCheckboxChange = (e) => {
		const id = e.target.value;
		const { checkedFields } = this.state;
		const newCheckedFields = checkedFields.includes(id)
			? checkedFields.filter((fieldId) => fieldId !== id)
			: [...checkedFields, id];
		this.setState({ checkedFields: newCheckedFields });
	};

	// Handle "Select All" checkbox change
	handleSelectAllChange = () => {
		const { rvss, checkedFields } = this.state;
		const allSelected = checkedFields.length === rvss.length;
		const newCheckedFields = allSelected
			? []
			: rvss.map((list) => list._id);
		this.setState({ checkedFields: newCheckedFields });
	};

	// Sorting columns
	handleSort = (sortColumn) => {
		this.setState({ sortColumn });
	};

	handlePageChange = (page) => {
		this.setState({ currentPage: page });
	};

	handleSearch = (query) => {
		this.setState({ searchQuery: query, currentPage: 1 });
	};
	getDataPgnation = () => {
		const {
			pageSize,
			currentPage,
			rvss,
			sortColumn,
			searchQuery,
		} = this.state;

		let filtered = rvss;
		if (searchQuery) {
			const lowerSearch = searchQuery.toLowerCase();
			filtered = rvss.filter(
				(el) =>
					(el.codeNr && String(el.codeNr).toLowerCase().includes(lowerSearch)) ||
					(el.RVS && String(el.RVS).toLowerCase().includes(lowerSearch)) ||
					(el.itemBatch && String(el.itemBatch).toLowerCase().includes(lowerSearch)) ||
					(el.bookingWay && String(el.bookingWay).toLowerCase().includes(lowerSearch))
			);
		}

		const sorted = _.orderBy(filtered, [sortColumn.path], [sortColumn.order]);
		let nrvss = paginate(sorted, currentPage, pageSize);
		return { data: nrvss };
	};

	render() {
		const { length: count } = this.state.rvss;
		const { rvss, pageSize, currentPage, sortColumn, searchQuery, checkedFields } = this.state;
		const { data } = this.getDataPgnation();

		return (
			<div>
				<ToastContainer />				<ol className="breadcrumb float-xl-right">
					<li className="breadcrumb-item">
						<Link to="/ERP/rvss">RVSs</Link>
					</li>
				</ol>
				<h1 className="page-header">RVS Management</h1>				<Panel>
					<PanelHeader>RVS Management</PanelHeader>
					<React.Fragment>
						{/* {user && ( <button className="btn btn-default active m-r-5 m-b-5" style={{marginBottom:20},{marginLeft:20},{marginTop:20}}>  <Link to="/clinic/user/new">Add User</Link>  </button>)} */}						<div className="toolbar" style={toolbarStyles}>							<button
								className="btn btn-default active m-r-5 m-b-5"
								title="Add RVS"
								style={btnStyles}
							>
								{" "}
								<Link to="/ERP/rvss/new">
									<img style={iconStyles} src={newIcon} alt="New Icon" />
								</Link>{" "}
							</button>		
							<button
								className="btn btn-default active m-r-5 m-b-5"
								title="Edit RVS"
								style={btnStyles}
								disabled={this.state.checkedFields.length !== 1}
							>
								{" "}
								<Link
									to={
										this.state.checkedFields.length === 1
											? `/ERP/rvss/${this.state.checkedFields[0]}`
											: "#"
									}								>
									<img style={iconStyles} src={editIcon} alt="Edit Icon" />
								</Link>{" "}							</button>
							<button
								className="btn btn-default active m-r-5 m-b-5"
								title="Delete RVS"
								style={btnStyles}
								disabled={this.state.checkedFields.length === 0}
								onClick={() =>
									this.handleMassDelete(this.state.checkedFields)
								}
							>
								{" "}
								{/* <Link to="/accounting/rvss/del"> */}
								<img style={{ width: "25px", height: "25px" }} src={trashIcon} alt="Trash Icon" />
								{/* </Link>{" "} */}
							</button>
							<button
								className="btn btn-default active m-r-5 m-b-5"
								title="excel"
								style={btnStyles}
							>
								{" "}
								<Link to="#">
									<img style={iconStyles} src={xlsIcon} alt="XLS Icon" />
								</Link>{" "}
							</button>
							<button
								className="btn btn-default active m-r-5 m-b-5"
								title="csv"
								style={btnStyles}
							>
								{" "}
								<Link to="#">
									<img style={iconStyles} src={csvIcon} alt="CSV Icon" />
								</Link>{" "}
							</button>

							<button
								className="btn btn-default active m-r-5 m-b-5"
								title="pdf"
								style={btnStyles}
							>
								{" "}
								<Link to="#">
									<img style={iconStyles} src={pdfIcon} alt="PDF Icon" />
								</Link>{" "}
							</button>
							<button className="btn btn-default active m-r-5 m-b-5" title="Share to other" style={btnStyles}>
								{" "}
								<Link to="#">
									<img style={iconStyles} src={sharingIcon} alt="Sharing Icon" />
								</Link>{" "}
							</button>
							<button className="btn btn-default active m-r-5 m-b-5" title="Upload XLS to Database" style={btnStyles}>
								{" "}
								<Link to="#">
									<img style={iconStyles} src={importIcon} alt="Upload XLS" />
								</Link>{" "}
							</button>
									
						</div>
						{/* <button
							className="btn btn-default active m-r-5 m-b-5"
							title="download"
							style={
								({ marginBottom: 20 },
								{ marginLeft: 20 },
								{ marginTop: 20 })
							}
						>
							{" "}
							<Link to="/accounting/rvss/download">
								<i className="ion-md-download"></i>
							</Link>{" "}
						</button> */}

						<div className="table-responsive">
							<SearchBox
								value={searchQuery}
								onChange={this.handleSearch}
							/>
							<p
								className="page-header float-xl-left"
								style={
									({ marginBottom: 5 },
										{ marginLeft: 20 },
										{ marginTop: 5 })
								}
							>
								{count} entries
							</p>							<RVSsTable
								rvss={data}
								onSort={this.handleSort}
								sortColumn={sortColumn}
								handleSelectAllChange={this.handleSelectAllChange}
								handleCheckboxChange={this.handleCheckboxChange}
								checkedFields={this.state.checkedFields}
							/>
						</div>
					</React.Fragment>


					<hr className="m-0" />
					<PanelBody>						<div className="d-flex align-items-center justify-content-center">
							<Pagination
								itemsCount={count}
								pageSize={pageSize}
								onPageChange={this.handlePageChange}
								currentPage={currentPage}
							/>
						</div>
					</PanelBody>
				</Panel>
			</div>
		);
	}
}

const toolbarStyles = { background: "#c8e9f3", padding: "10px" };
const btnStyles = { background: "#348fe2", margin: "0rem" };
const iconStyles = { width: "25px", height: "25px", marginRight: "0rem" };

export default rvsTable;
